import React, { useState } from "react";
import styled from "styled-components";
import { Typography, Tabs } from "@bracket/ui";
import { useInOrOutStore } from "../../store/InOrOutStore";
import { TableRecentWins } from "./TableRecentWins";
import { TableYourDailyPlays } from "./TableYourDailyPlays";

const ChartTableWrapper = styled.div`
  display: flex;
  flex-flow: column;
`;

const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
`;

const TabContent = styled.div`
  margin-top: 1rem;
`;

export const ChartTable: React.FC = () => {
  const { tableRecentBars, tableYourDailyPlays } = useInOrOutStore();
  const [activeTab, setActiveTab] = useState("recentWins");

  const tabItems = [
    { id: "recentWins", label: "Recent wins" },
    { id: "yourPlays", label: "Your plays" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "recentWins":
        return tableRecentBars?.length ? (
          <TableRecentWins />
        ) : (
          <NoDataWrapper>
            <Typography variant="p">No data</Typography>
          </NoDataWrapper>
        );
      case "yourPlays":
        return tableYourDailyPlays?.length ? (
          <TableYourDailyPlays data={tableYourDailyPlays} />
        ) : (
          <NoDataWrapper>
            <Typography variant="p">No data</Typography>
          </NoDataWrapper>
        );
      default:
        return null;
    }
  };

  return (
    <ChartTableWrapper>
      <Tabs items={tabItems} activeTab={activeTab} onTabChange={setActiveTab} />
      <TabContent>{renderTabContent()}</TabContent>
    </ChartTableWrapper>
  );
};
